import React, { useState, useRef, useEffect } from 'react';

import { ToolbarForm } from '../../utils/toolbar-form/ToolbarForm';


import { withLoadPanel } from '../../../utils/withLoadPanel';
import From, { Item as ItemForm, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import Validator, { PatternRule, EmailRule } from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';

import { FormPhoto } from '../../utils/form-photo/FormPhoto';

import { FormTextbox } from '../../utils/form-textbox/FormTextbox';

import ValidationGroup from 'devextreme-react/validation-group';

import './ClubForm.scss';
import classNames from 'classnames';
import { DateBox } from 'devextreme-react';
import { FormDateBox } from '../../utils/form-datebox/FormDateBox';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { FormCheckBox } from '../../utils/form-checkbox/FormCheckBox';
import { checkPermission } from '../../../permissions';



export const ClubForm = ({ data, isLoading = false, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState(data.club);
  const dataRef = useRef();
  const stylingMode = 'filled';

  useEffect(() => {

    setFormData(data.club);

  }, [data]);

  const handleEditClick = () => {
    if (editing === false && formData) {
      dataRef.current = formData;
    } else {
      dataRef.current = undefined;
    }
    setEditing(!editing);
  };

  const onSaveClick = ({ validationGroup }) => {
    if (!validationGroup.validate().isValid) return;
    handleEditClick();
    onSave(formData);
  };

  const onCancelClick = () => {
    setFormData(dataRef.current);
    handleEditClick();
  };

  const updateField = (field) => (value) => {
    if (!formData) return;

    setFormData({ ...formData, ...{ [field]: value } });
  };

  return (
    <div className='club-form'>
      <ValidationGroup>
        <ToolbarForm toggleEditing={handleEditClick} onSaveClick={onSaveClick} editing={editing} onCancelClick={onCancelClick} allowEditing={checkPermission('club.edit')} />
        <From
          className={classNames({ 'plain-styled-form': true, 'view-mode': !editing })}
          labelMode='floating'
        >
          <GroupItem colCount={2}>
            <ColCountByScreen xs={2} />

            <ItemForm>
                <FormTextbox
                  label='Vereinsname'
                  value={formData.clubname}
                  isEditing={!editing}
                  onValueChange={updateField('clubname')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Kurzname Verein'
                  value={formData.shortclubname}
                  isEditing={!editing}
                  onValueChange={updateField('shortclubname')}
                />
              </ItemForm>
              <ItemForm>
                <FormTextbox
                  label='Vorname'
                  value={formData.surname}
                  isEditing={!editing}
                  onValueChange={updateField('surname')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Nachname'
                  value={formData.lastname}
                  isEditing={!editing}
                  onValueChange={updateField('lastname')}
                />
              </ItemForm>

            

              <ItemForm>
                <FormTextbox
                  label='DSV-ID'
                  value={formData.dsvId}
                  isEditing={!editing}
                  onValueChange={updateField('dsvId')}
                />
              </ItemForm>

              <ItemForm>
                <FormCheckBox
                  label='Aktiv'
                  value={formData.activ}
                  readOnly={!editing}
                  onValueChange={updateField('activ')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Straße'
                  value={formData.street}
                  isEditing={!editing}
                  onValueChange={updateField('street')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='PLZ'
                  value={formData.plz}
                  isEditing={!editing}
                  onValueChange={updateField('plz')}
                />
              </ItemForm>

              <ItemForm colSpan={1}>
                <FormTextbox
                  label='Stadt'
                  value={formData.city}
                  isEditing={!editing}
                  onValueChange={updateField('city')}
                />
              </ItemForm>
               <ItemForm colSpan={1}>
                <FormTextbox
                  label='LSV-Kennziffer'
                  value={formData.lsvkennziffer}
                  isEditing={!editing}
                  onValueChange={updateField('lsvkennziffer')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Telefon'
                  value={formData.phone}
                  isEditing={!editing}
                  onValueChange={updateField('phone')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='E-Mail'
                  value={formData.mail}
                  isEditing={!editing}
                  onValueChange={updateField('mail')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Kontoinhaber'
                  value={formData.accountholder}
                  isEditing={!editing}
                  onValueChange={updateField('accountholder')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='IBAN'
                  value={formData.iban}
                  isEditing={!editing}
                  onValueChange={updateField('iban')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='BIC'
                  value={formData.bic}
                  isEditing={!editing}
                  onValueChange={updateField('bic')}
                />
              </ItemForm>

              <ItemForm>
                <FormTextbox
                  label='Bank'
                  value={formData.bank}
                  isEditing={!editing}
                  onValueChange={updateField('bank')}
                />
              </ItemForm>
            
           
          
          </GroupItem>


        </From>
      </ValidationGroup>
    </div>
  );
};
